import Repository from './Repository'
import TokenService from '../helpers/token'

const resource = `${Repository.defaults.baseURL}`

export default {  
  async getListKB(params) {
    const response = await Repository.get(`${resource}/brand-name/scripts`, {
        params,
        headers: TokenService.getHeader(),
    })
    return response
  },
  async getListBrands() {
    const response = await Repository.get(`${resource}/brand-name/scripts/list-brands`, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async getListUserScripts(params) {
    const response = await Repository.get(`${resource}/brand-name/user-scripts`, {
      params,
      headers: TokenService.getHeader(),
    })
    return response
  },
  async updateUserScripts(id, params) {
    const response = await Repository.put(`${resource}/brand-name/user-scripts/${id}`, params, {
        headers: TokenService.getHeader(),
    })
    return response
  },
  async createBrand(params) {
    const response = await Repository.post(`${resource}/brand-name/scripts`,params, {
      headers: TokenService.getHeader(),
    })
    return response
  },
  async deleteScriptSale(userId) {
    const response = await Repository.delete(`${resource}/brand-name/user-scripts/${userId}`, {
        headers: TokenService.getHeader(),
    })
    return response
  },
  async deleteBrand(code) {
    const response = await Repository.delete(`${resource}/brand-name/scripts/${code}`, {
        headers: TokenService.getHeader(),
    })
    return response
  },
  async updateBrand(code , params) {
    const response = await Repository.put(`${resource}/brand-name/scripts/${code}`, params, {
      headers: TokenService.getHeader(),
  })
  return response
  },
  async getListGroups() {
    const response = await Repository.get(`${resource}/brand-name/groups`, {
      headers: TokenService.getHeader(),
  })
  return response
  },
  async getListBrandName() {
    const response = await Repository.get(`${resource}/brand-name/list-brands`, {
      headers: TokenService.getHeader(),
    })
    return response
  },
}
